module.exports = __webpack_public_path__ + "media/img/automated-testing/benefits/benefits-img1-3b3f28b0519c6401c458fdb1ebaecf04.svg";